import { saveCostsGridState as saveCostsGridStateDiagram  } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {
    columnState: [];
};

export const saveCostsGridState = ({
    columnState,
}: Props) => {
    saveCostsGridStateDiagram(columnState);
};
